import types from '../types'

const initialState = {
  availableModeIds: [],
  isError: false,
  isLoading: false,
  hasLoaded: false,
  surfaceData: null,
  flightData: null,
}

const searchConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CONFIG_RECEIVED:
      return handleConfigReceived(state, action.payload)
    case types.CONFIG_FAILED:
      return handleConfigFailed(state)
    default:
      return state
  }
}

// Update configuration status, create modesInfo for each returned kind
const handleConfigReceived = (state, payload) => {
  const modeIds = payload.transitKinds
  const surfaceData = payload.surfaceData
  const flightData = payload.flightData

  const availableModeIds = modeIds.map((kind) => kind.transitKind)

  return {
    ...state,
    availableModeIds,
    isError: false,
    isLoading: false,
    hasLoaded: true,
    surfaceData,
    flightData,
  }
}

const handleConfigFailed = (state) => {
  return {
    ...state,
    isError: true,
    hasLoaded: true,
    isLoading: false,
    surfaceData: null,
    flightData: null,
  }
}

export default searchConfigReducer
